var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgKpi = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.75,
  y: 0.75,
  width: 30.5,
  height: 30.5,
  className: "widget_icon_line_stroke",
  strokeWidth: 1.5
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M16.5239 16.173H14.75L14.0882 19.9414H12.4063L13.068 16.173H10.9816V14.5921H13.3438L13.8033 11.9818H11.671V10.3826H14.0882L14.7592 6.55905H16.432L15.761 10.3826H17.5441L18.2151 6.55905H19.8971L19.2261 10.3826H21.239V11.9818H18.9412L18.4816 14.5921H20.5404V16.173H18.2059L17.5441 19.9414H15.8621L16.5239 16.173ZM15.0257 14.5921H16.7996L17.2592 11.9818H15.4761L15.0257 14.5921Z",
  className: "widget_icon_line"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M9.17651 26.5843L11.7647 23.9961L14.353 26.5843H9.17651Z",
  fill: "#048119"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M22.3529 24.0016L19.7647 26.5898L17.1764 24.0016L22.3529 24.0016Z",
  fill: "#D90400"
})));
export { SvgKpi as ReactComponent };
export default __webpack_public_path__ + "kpi.e96f136c8f87f8029645b07f630927de.svg";